// @flow
import React, { useCallback, useState } from 'react';
import { navigate } from '@reach/router';

import { budgetVersionApi } from '../../lib/api';
import type { UserAccess, BudgetVersion } from '../../lib/types';
import { getValueObject } from '../../lib/helpers';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';

const { Field } = Card;

type InnerProps = {
  data: BudgetVersion
};

type CardProps = {
  id: number,
  userAccess: UserAccess[]
};

const entryPointPath = '/admin/budget-version/';

const InnerForm = (props: InnerProps) => {
  return (
    <>
      <Grid gutter="16px">
        <GridItem>
          <Field label="Наименование">
            {getValueObject(props, 'data.name')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Доступно для выбора пользователем при формирование предложений">
            {getValueObject(props, 'data.isAvailableForSelect')
              ? 'Доступно'
              : 'Недоступно'}
          </Field>
        </GridItem>
      </Grid>
    </>
  );
};

export default withUserAccess((props: CardProps) => {
  const [data: BudgetVersion, setData] = useState({
    id: props.id,
    name: '',
    isAvailableForSelect: false
  });

  const breadCrumbs = [
    { to: '/', name: 'Главная' },
    { name: 'Справочники' },
    { to: `${entryPointPath}`, name: 'Версии бюджета' },
    { to: `${entryPointPath}${data.id}`, name: data.id.toString() }
  ];

  const canEdit = props.userAccess.some(access =>
    addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit
      ? async () => {
          await budgetVersionApi.delete(data.id);
          await navigate(`${entryPointPath}`);
        }
      : false,
    edit: canEdit
      ? async () => await navigate(`${entryPointPath}edit/${data.id}`)
      : false
  };

  const onFetch = useCallback(async () => {
    setData(await budgetVersionApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Версии бюджета',
        access
      }}
      onFetch={onFetch}
    >
      <InnerForm data={data} />
    </CommonCardPage>
  );
});
